import { useGetIdentity, useOne } from "@refinedev/core";
import CircularProgress from '@mui/material/CircularProgress';
import { Profile } from "components";
import { ThemeProvider } from "@mui/material";
import { DarkTheme } from "@refinedev/mui";

const MyProfile = () => {
    const { data: user } = useGetIdentity({
        v3LegacyAuthProviderCompatible: true,
    });
    const { data, isLoading, isError } = useOne({
        resource: "users",
        id: user?.userid,
    });

    const myProfile = data?.data ?? [];

    if (isLoading) return <ThemeProvider theme={DarkTheme}>Loading...<CircularProgress color="warning"/></ThemeProvider>;
    if (isError) return <div>error...</div>;

    return (
        <Profile
            type="My"
            name={myProfile.name}
            email={myProfile.email}
            avatar={myProfile.avatar}
            properties={myProfile.allProperties}
        />
    );
};

export default MyProfile;